import { NotificationType, showNotificationToast } from '@genesislcap/foundation-notifications';

export function notifyError(body = 'Error', type: NotificationType = 'error', iconName = 'bell') {
  showNotificationToast(
    {
      title: 'Error',
      body,
      iconName,
      toast: { type, autoClose: true, closeTimeout: 3000 },
    },
    'rapid'
  );
}

export function notifyWarning(body = 'Warning', iconName = 'bell') {
  showNotificationToast(
    {
      title: 'Warning',
      body,
      iconName,
      toast: { type: 'warning', autoClose: true, closeTimeout: 3000 },
    },
    'rapid'
  );
}

/** Show error or warning toast based on API error CODE. Use for commitEvent response.ERROR[0]. Validation codes show as warning. */
export function notifyApiError(error: { CODE?: string; TEXT?: string } | null | undefined): void {
  if (!error?.TEXT) return;
  const isValidation = error.CODE === 'VALIDATION_WARNING' || error.CODE === 'VALIDATION_ERROR';
  if (isValidation) {
    notifyWarning(error.TEXT);
  } else {
    notifyError(error.TEXT);
  }
}
